export default {
  TABLET: '@media (min-width: 768px)',
  DESKTOP: '@media (min-width: 1024px)',
  FULLWIDH: '@media (min-width: 1200px)',
  MOBILE: '@media (max-width: 768px)',
  FULLWIDHMAX: '@media (max-width: 1200px)',
}
